import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {AppContext} from '../app-context';
import moment from 'moment';
import {release} from "../../release";

export abstract class RequestGateway {
  private handlers = [];

  protected constructor(private http: HttpClient, private httpEndpoint: string) {
  }

  send(type: string, message: any, options?): Observable<any> {
    const handler = this.handlers.find(h => h[type]);
    if (handler) {
      console.debug("sending request to local handler", type, message);
      try {
        const result = handler[type](getPayload(message));
        return result instanceof Observable ? result : of(result);
      } catch (e) {
        return new Observable(subscriber => subscriber.error(e));
      }
    } else {
      console.debug("sending http request", type, message);
      message = asMessage(message, type);
      message.metadata.frontendVersion = release;
      message.metadata.localTime = moment().toLocaleString();
      message.metadata.userEmail = AppContext.userProfile && AppContext.userProfile.organisation &&
        AppContext.userProfile.organisation.emailAddress;
      return this.http.post<any>(this.httpEndpoint, message, options);
    }
  }

  registerLocalHandler(handler) {
    this.handlers.push(handler);
    return () => this.handlers = this.handlers.filter(h => h !== handler);
  }

  registerLocalHandlers(...handlers) {
    const subscriptions: any[] = handlers.map(h => this.registerLocalHandler(h));
    return () => subscriptions.forEach(s => s());
  }
}

function getPayload(message: any) {
  return message['@class'] === 'io.fluxzero.sdk.common.Message' ? message.payload : message;
}

function asMessage(payload: any, type: string) {
  //payload is already a message
  if (payload['@class'] === 'io.fluxzero.sdk.common.Message') {
    payload.metadata = payload.metadata || {};
    payload.payload["@class"] = type;
    return payload;
  }

  //payload should be converted to a message
  payload["@class"] = type;
  return {
    "@class": 'io.fluxzero.sdk.common.Message',
    payload: payload,
    metadata: {}
  }
}
